import { Badge } from '@/components/ui/badge';

const statusConfig = {
  placed: { label: 'Placed', classes: 'bg-slate-100 text-slate-800 border-slate-200' },
  confirmed: { label: 'Confirmed', classes: 'bg-sky-50 text-sky-900 border-sky-200' },
  preparing: { label: 'Preparing', classes: 'bg-amber-50 text-amber-900 border-amber-200' },
  ready: { label: 'Ready', classes: 'bg-teal-50 text-teal-900 border-teal-200' },
  assigned: { label: 'Assigned', classes: 'bg-indigo-50 text-indigo-900 border-indigo-200' },
  picked_up: { label: 'Picked Up', classes: 'bg-cyan-50 text-cyan-900 border-cyan-200' },
  in_transit: { label: 'In Transit', classes: 'bg-blue-50 text-blue-900 border-blue-200' },
  delivered: { label: 'Delivered', classes: 'bg-emerald-50 text-emerald-900 border-emerald-200' },
  cancelled: { label: 'Cancelled', classes: 'bg-rose-50 text-rose-800 border-rose-200' },
};

export function OrderStatusBadge({ status }) {
  const config = statusConfig[status] || { label: status, classes: 'bg-slate-100 text-slate-800' };
  return (
    <Badge variant="outline" className={`status-badge ${config.classes} text-xs font-medium`}>
      {config.label}
    </Badge>
  );
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);
}

export function formatDate(dateStr) {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return dateStr;
  }
}
